import {
  ISubscriptionPresentation,
} from '@/domain/stripe/customer/sub-domains/subscription/presentation/contract/ISubscriptionPresentation'

export class SubscriptionPaymentFailurePresentation extends Error implements ISubscriptionPresentation {

}
